import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FaPhoneAlt, FaSun, FaTimes, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import SITE from '../../Data/siteConfig';
import useSummerCampaign from './useSummerCampaign';
import './SummerCampaignModal.css';

const MODAL_DELAY_MS = 800;

const SummerCampaignModal = () => {
  const { campaign, shouldShowModal, dismiss } = useSummerCampaign();
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);
  const closeBtnRef = useRef(null);
  const dialogRef = useRef(null);

  const handleClose = useCallback(() => {
    setVisible(false);
    setTimeout(() => {
      dismiss();
      setMounted(false);
    }, 280);
  }, [dismiss]);

  useEffect(() => {
    if (!shouldShowModal) {
      setMounted(false);
      setVisible(false);
      return undefined;
    }

    const timer = setTimeout(() => {
      setMounted(true);
      requestAnimationFrame(() => setVisible(true));
    }, MODAL_DELAY_MS);

    return () => clearTimeout(timer);
  }, [shouldShowModal]);

  useEffect(() => {
    if (!mounted) return undefined;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeBtnRef.current?.focus();

    const onKeyDown = (e) => {
      if (e.key === 'Escape') handleClose();
    };
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [mounted, handleClose]);

  if (!mounted) return null;

  const whatsappHref = SITE.whatsappMessage(campaign.whatsappText);

  return (
    <div
      className={`scm-overlay ${visible ? 'scm-overlay--visible' : ''}`}
      onClick={handleClose}
      aria-hidden={!visible}
    >
      <div
        ref={dialogRef}
        className={`scm-dialog ${visible ? 'scm-dialog--visible' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="scm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          ref={closeBtnRef}
          type="button"
          className="scm-close"
          onClick={handleClose}
          aria-label="Kampanyayı kapat"
        >
          <FaTimes />
        </button>

        <div className="scm-icon-wrap" aria-hidden>
          <FaSun className="scm-sun" />
        </div>

        <span className="scm-badge">{campaign.title}</span>

        <h2 id="scm-title" className="scm-title">
          {campaign.serviceName}
        </h2>

        <div className="scm-price-badge scm-price-pulse">{campaign.priceDisplay}</div>

        <p className="scm-desc">
          {campaign.endDateDisplay}&apos;a kadar geçerli yaz kampanyası. Detaylı klima bakımı
          için hemen arayın veya WhatsApp&apos;tan yazın.
        </p>

        <div className="scm-actions btn-group">
          <a href={SITE.phoneHref} className="btn btn-call">
            <FaPhoneAlt className="btn-icon" /> Hemen Ara
          </a>
          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-whatsapp"
          >
            <FaWhatsapp className="btn-icon" /> WhatsApp
          </a>
        </div>

        <Link to={campaign.detailPath} className="scm-detail-link" onClick={handleClose}>
          Kampanya detayları →
        </Link>
      </div>
    </div>
  );
};

export default SummerCampaignModal;
